import { TouchableOpacity, View, Platform, Text } from 'react-native'
import { DesignSystem } from '@/src/design-system'
import FontAwesome from '@expo/vector-icons/FontAwesome'
import { useRouter } from 'expo-router'
import { NotificationsRoutes as Routes } from '../navigation/routes'
import { NotificationsApi } from '../store/api'
import { mesaColorNames, typography } from '@/src/common/theme'

export const EnablePermissionsBanner = ({ text }: { text: string }) => {
  const router = useRouter()

  const { data: permissions, isSuccess } =
    NotificationsApi.endpoints.getNotificationsPermissions.useQuery()

  const color = mesaColorNames['Mesa - Brand/White #FFFFFF']
  const backgroundColor = 'rgb(213, 89, 0)'

  if (
    isSuccess &&
    !permissions.granted &&
    !permissions.canAskAgain &&
    permissions.isMoreThan1MonthSinceLastRequest &&
    ['ios', 'android'].includes(Platform.OS)
  ) {
    return (
      <TouchableOpacity
        style={{ width: '100%' }}
        onPress={() => router.push(Routes.GoToSystemSettings.route)}
      >
        <DesignSystem.Card
          style={{
            borderColor: backgroundColor,
            borderWidth: 1,
            backgroundColor,
            padding: 16,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
            }}
          >
            <View
              style={{
                justifyContent: 'space-evenly',
                marginRight: 12,
              }}
            >
              <FontAwesome name="bell" size={24} color={color} />
            </View>

            <View style={{ flex: 1 }}>
              <View>
                <Text style={[typography['Base Bold'], { color }]} numberOfLines={1}>
                  Enable Push Notifications
                </Text>
              </View>

              <Text style={[typography.S, { color }]}>{text}</Text>
            </View>
          </View>
        </DesignSystem.Card>
      </TouchableOpacity>
    )
  } else {
    return <></>
  }
}
